/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import styles from './styles/controls.css';

export const VolumeButton = ({
  muted,
  canAudioStateBeChanged,
  changeMuteState
}) => (
  <i
    id="muteAudio"
    title={muted ? 'Unmute' : 'Mute'}
    onClick={() => canAudioStateBeChanged && changeMuteState(!muted)}
    className={`${muted ? styles.muted : styles.unmuted} ${
      canAudioStateBeChanged ? '' : styles.disabled
    }`}
  />
);

VolumeButton.propTypes = {
  canAudioStateBeChanged: PropTypes.bool.isRequired,
  muted: PropTypes.bool.isRequired,
  changeMuteState: PropTypes.func.isRequired
};

export default VolumeButton;